import React, { useRef, useEffect } from 'react';
import videoSource from '../../../assets/videos/HeaderVideo.mp4';
import CustomButton from '../../CustomButton';
import { motion } from 'framer-motion';
import iustiaLogo from '../../../assets/images/logos/iustia-logo-white.svg';
import { useUI } from '../../../redux/hooks';

export default function Hero() {
  const videoRef = useRef(null);
  const heroRef = useRef(null);
  const { setIsInHeroSection } = useUI();

  useEffect(() => {
    if (videoRef.current) {
      videoRef.current.play().catch(error => {
        console.log('Error playing video:', error);
      });
    }
  }, []);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        // Si el hero está visible (intersecting), estamos en la sección del hero
        setIsInHeroSection(entry.isIntersecting);
      },
      {
        threshold: 0.1, // Se considera visible cuando al menos 10% está visible
      }
    );

    const currentHeroRef = heroRef.current;
    if (currentHeroRef) {
      observer.observe(currentHeroRef);
    }

    return () => {
      if (currentHeroRef) {
        observer.unobserve(currentHeroRef);
      }
    };
  }, [setIsInHeroSection]);

  return (
    <div ref={heroRef} className="w-full h-full relative overflow-hidden">
      <video
        ref={videoRef}
        className="w-full object-cover min-h-screen"
        autoPlay
        loop
        muted
        playsInline
      >
        <source src={videoSource} type="video/mp4" />
        Your browser does not support the video tag.
      </video>

      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.5 }}
        className="absolute inset-0"
        style={{
          background: 'linear-gradient(180deg, rgba(10, 19, 35, 0) 0%, #0A1323 110%)',
        }}
      ></motion.div>

      <div className="absolute inset-0 flex flex-col items-center justify-center px-6 mx-auto">
        <motion.img
          src={iustiaLogo}
          alt="Iustia Logo"
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.4, ease: 'easeOut' }}
          className="h-20 mb-8"
        />

        <motion.h1
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.3, ease: 'easeOut' }}
          className="text-white font-serif font-light text-2xl tracking-[0%] leading-none text-center max-w-2xl mx-auto px-6"
        >
          La <span className="font-serif font-bold italic">justicia</span> jamás había sido
          <span className="font-serif font-bold italic"> tan fácil.</span>
        </motion.h1>

        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.2, delay: 0.3 }}
          className="flex flex-row items-center justify-center gap-4 mt-8"
        >
          <CustomButton text="Busca un abogado" />
          <CustomButton text="Consulta express" variant="outline" />
        </motion.div>
      </div>
    </div>
  );
}
